/* ============================================================
   Dexter Gym Wear - behaviour layer
   1. offer ladder rail auto-advance
   2. product page bundle builder (mix any products + sizes)
   3. low stock line, driven by real inventory, no exact counts
   4. cart drawer ladder progress
   All guarded so a missing element never throws.
   ============================================================ */
(function () {
  'use strict';

  var LOW = 5;
  var TIERS = [
    { q: 1, perk: null, off: 0 },
    { q: 2, perk: 'Free shipping', off: 0 },
    { q: 3, perk: '10% off + free shipping', off: 0.10 }
  ];

  var MONEY_FMT = 'LE {{amount}}';
  /* Decimals are kept when they exist. A 10% discount lands on .30 more
     often than not, and rounding it away would advertise a lower price
     than Shopify actually charges at checkout. */
  function money(cents) {
    var n = cents / 100;
    var whole = Math.abs(n % 1) < 0.005;
    var s = whole
      ? Math.round(n).toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY_FMT.replace(/\{\{[^}]*\}\}/, s);
  }

  var catalog = null, byHandle = {};
  function loadCatalog() {
    var dataEl = document.getElementById('dx-catalog');
    if (!dataEl) return false;
    try { catalog = JSON.parse(dataEl.textContent); } catch (e) { return false; }
    if (!catalog || !catalog.products || !catalog.products.length) return false;
    if (catalog.money_format) MONEY_FMT = catalog.money_format;
    byHandle = {};
    catalog.products.forEach(function (p) { byHandle[p.handle] = p; });
    return true;
  }

  function currentSize() {
    var checked = document.querySelectorAll(
      'variant-selects input[type=radio]:checked, .product-form__input input[type=radio]:checked'
    );
    if (!checked.length) return null;
    return checked[checked.length - 1].value.trim();
  }

  /* ---------- 1. ladder rail ---------- */
  function initRail() {
    var tiers = document.querySelectorAll('.dx-tier');
    if (!tiers.length || window.__dxRail) return;
    var i = -1;
    function step() {
      tiers.forEach(function (t) { t.classList.remove('dx-hot'); });
      i = (i + 1) % tiers.length;
      tiers[i].classList.add('dx-hot');
    }
    step();
    window.__dxRail = setInterval(step, 2300);
  }

  /* ---------- 3. low stock line ---------- */
  function paintStock() {
    var box = document.getElementById('dx-stock');
    if (!box || !catalog) return;
    var p = byHandle[catalog.current];
    if (!p) return;
    var size = currentSize();
    var v = p.variants.filter(function (x) { return x.size === size; })[0] || p.variants[0];
    if (!v) return;
    var low = v.qty <= LOW;
    box.className = 'dx-stock' + (low ? '' : ' dx-ok');
    box.innerHTML = '<i class="dx-dot"></i><span>' + (low
      ? '<b>Low stock</b> in size ' + v.size + '. This size sells out first.'
      : '<b>In stock</b> in size ' + v.size + '.') + '</span>';
  }

  /* ---------- 2. bundle builder ---------- */
  function initBundle() {
    var root = document.getElementById('dx-bundle-root');
    if (!root || !catalog) return;

    var current = byHandle[catalog.current] || catalog.products[0];
    var state = { qty: 1, slots: [] };

    function firstAvail(p) {
      var v = p.variants.filter(function (x) { return x.qty > 0; })[0] || p.variants[0];
      return v.size;
    }
    function variantOf(p, size) {
      return p.variants.filter(function (v) { return v.size === size; })[0];
    }
    function ensureSlots() {
      var s = state.slots;
      if (!s.length) s.push({ h: current.handle, size: currentSize() || firstAvail(current) });
      while (s.length < state.qty) {
        var used = s.map(function (x) { return x.h; });
        var next = catalog.products.filter(function (p) {
          return used.indexOf(p.handle) === -1;
        })[0] || catalog.products[0];
        s.push({ h: next.handle, size: firstAvail(next) });
      }
      s.length = state.qty;
    }
    function totals() {
      ensureSlots();
      var sub = 0, was = 0;
      state.slots.forEach(function (sl) {
        var p = byHandle[sl.h];
        var v = variantOf(p, sl.size) || p.variants[0];
        sub += v.price;
        was += (v.compare && v.compare > v.price) ? v.compare : v.price;
      });
      var t = TIERS.filter(function (x) { return x.q === state.qty; })[0] || TIERS[0];
      return { sub: sub, was: was, off: t.off, tot: sub * (1 - t.off), perk: t.perk };
    }

    function renderTierPick() {
      var wrap = root.querySelector('.dx-tierpick');
      var base = variantOf(current, currentSize()) || current.variants[0];
      wrap.innerHTML = TIERS.map(function (t) {
        var tot = base.price * t.q * (1 - t.off);
        return '<button type="button" class="dx-lt' + (t.q === state.qty ? ' dx-on' : '') +
          '" data-q="' + t.q + '">' +
          (t.q === 3 ? '<span class="dx-lt-tag">Best value</span>' : '') +
          '<span class="dx-radio"></span>' +
          '<span class="dx-lt-main"><b>' + t.q + (t.q === 1 ? ' piece' : ' pieces') + '</b>' +
          '<span class="' + (t.perk ? '' : 'dx-none') + '">' + (t.perk || 'Standard shipping') + '</span></span>' +
          '<span class="dx-lt-price"><b>' + money(tot) + '</b>' +
          (t.off ? '<s>' + money(base.price * t.q) + '</s>' : '') + '</span>' +
          '</button>';
      }).join('');
      wrap.querySelectorAll('.dx-lt').forEach(function (b) {
        b.addEventListener('click', function () {
          state.qty = parseInt(b.dataset.q, 10);
          renderTierPick();
          renderBundle();
        });
      });
    }

    function renderBundle() {
      var wrap = root.querySelector('.dx-bundle-wrap');
      var dawnForm = document.querySelector('.product-form');

      if (state.qty < 2) {
        wrap.innerHTML = '';
        if (dawnForm) dawnForm.style.display = '';
        return;
      }
      if (dawnForm) dawnForm.style.display = 'none';

      ensureSlots();
      var t = totals();
      var html = '<div class="dx-bundle">' +
        '<div class="dx-bundle-h"><b>Your bundle &middot; ' + state.qty + ' pieces</b>' +
        '<span>Mix any products and sizes</span></div>';

      state.slots.forEach(function (sl, i) {
        var p = byHandle[sl.h];
        html += '<div class="dx-slot"><span class="dx-num">' + (i + 1) + '</span>' +
          '<img src="' + p.image + '" alt="" loading="lazy">' +
          '<div class="dx-slot-main">' +
          '<select class="dx-sel" data-i="' + i + '">' +
          catalog.products.map(function (o) {
            return '<option value="' + o.handle + '"' + (o.handle === sl.h ? ' selected' : '') +
              '>' + o.title + ' &middot; ' + money(o.variants[0].price) + '</option>';
          }).join('') +
          '</select><div class="dx-sizes">' +
          p.variants.map(function (v) {
            var cls = v.qty <= 0 ? ' dx-out' : (v.qty <= LOW ? ' dx-thin' : '');
            if (v.size === sl.size) cls += ' dx-on';
            return '<button type="button" class="dx-sz' + cls + '" data-i="' + i +
              '" data-size="' + v.size + '">' + v.size + '</button>';
          }).join('') +
          '</div></div></div>';
      });

      html += '<div class="dx-bfoot"><span class="dx-l">' +
        (t.perk ? '&#10003; ' + t.perk : '') + '</span><span class="dx-r"><b>' + money(t.tot) + '</b>' +
        '<s>' + money(t.was) + '</s>' +
        (t.off ? ' <em>bundle saves ' + money(t.sub - t.tot) + '</em>' : '') +
        '</span></div></div>' +
        '<button type="button" class="button button--full-width dx-add">Add bundle to cart</button>';

      wrap.innerHTML = html;

      wrap.querySelectorAll('.dx-sel').forEach(function (s) {
        s.addEventListener('change', function () {
          var i = parseInt(s.dataset.i, 10);
          state.slots[i] = { h: s.value, size: firstAvail(byHandle[s.value]) };
          renderBundle();
        });
      });
      wrap.querySelectorAll('.dx-sz').forEach(function (b) {
        b.addEventListener('click', function () {
          state.slots[parseInt(b.dataset.i, 10)].size = b.dataset.size;
          renderBundle();
        });
      });
      wrap.querySelector('.dx-add').addEventListener('click', addBundle);
    }

    function addBundle(e) {
      var btn = e.currentTarget;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      var items = state.slots.map(function (sl) {
        var p = byHandle[sl.h];
        var v = variantOf(p, sl.size) || p.variants[0];
        return { id: v.id, quantity: 1 };
      });
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          btn.textContent = 'Added to cart';
          return refreshDrawer().then(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else window.location = window.Shopify.routes.root + 'cart';
          });
        })
        .then(function () {
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add bundle to cart';
          }, 1800);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Add bundle to cart';
          alert('Could not add the bundle: ' + err.message);
        });
    }

    renderTierPick();
    renderBundle();

    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches('input[type=radio]')) {
        paintStock();
        if (state.qty < 2) renderTierPick();
      }
    });
  }

  function refreshDrawer() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        var live = document.querySelector('cart-drawer');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          live.classList.remove('is-empty');
        }
        return updateProgress();
      })
      .catch(function () {});
  }

  /* ---------- 4. cart drawer ladder progress ---------- */
  var lastCount = null;

  function progressMarkup(count) {
    var pct = Math.min(count / 3, 1) * 100;
    var msg = count === 0 ? 'Add 2 pieces to unlock free shipping'
      : count === 1 ? 'Add 1 more for free shipping'
        : count === 2 ? 'Add 1 more for 10% off'
          : 'You unlocked 10% off and free shipping';
    /* mark labels are kept short so the three of them stay on one line
       across a narrow cart drawer on mobile */
    return '<div class="dx-prog-txt">' +
      (count >= 3 ? '<span class="dx-tick">&#10003;</span>' : '') +
      '<b>' + msg + '</b></div>' +
      '<div class="dx-bar"><i class="' + (count >= 3 ? 'dx-full' : '') + '" style="width:' + pct + '%"></i></div>' +
      '<div class="dx-marks">' +
      '<span class="' + (count >= 1 ? 'dx-hit' : '') + '">1</span>' +
      '<span class="' + (count >= 2 ? 'dx-hit' : '') + '">2 &middot; free ship</span>' +
      '<span class="' + (count >= 3 ? 'dx-hit' : '') + '">3 &middot; 10% off</span></div>';
  }

  function updateProgress() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var justUnlocked = lastCount !== null && lastCount < 3 && count >= 3;
        var hosts = document.querySelectorAll('cart-drawer .drawer__inner, #main-cart-items');
        hosts.forEach(function (host) {
          var bar = host.querySelector('.dx-prog');
          if (!bar) {
            bar = document.createElement('div');
            bar.className = 'dx-prog';
            var anchor = host.querySelector('.drawer__header');
            if (anchor && anchor.nextSibling) host.insertBefore(bar, anchor.nextSibling);
            else host.insertBefore(bar, host.firstChild);
          }
          bar.innerHTML = progressMarkup(count);
          if (justUnlocked) {
            bar.classList.remove('dx-win');
            void bar.offsetWidth;
            bar.classList.add('dx-win');
          }
        });
        lastCount = count;
      })
      .catch(function () {});
  }

  function watchCart() {
    updateProgress();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__dxWatched) return;
    drawer.__dxWatched = true;
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(updateProgress, 180);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    loadCatalog();
    initRail();
    paintStock();
    initBundle();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
